import React, { useEffect, useMemo, useState } from 'react';
import { initialize, whenAvailable } from '@vp/ab-reader';
import { FeatureGatesContext } from './FeatureGatesContext';

const GATE_TIMEOUT = 1000;

export const FeatureGatesProvider = (props: React.PropsWithChildren) => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    initialize();

    let mounted = true;
    whenAvailable(() => {
      if (mounted) {
        setIsInitialized(true);
      }
    }, GATE_TIMEOUT);

    return () => {
      mounted = false;
    };
  }, []);

  const ctxValue = useMemo(() => ({ isInitialized }), [isInitialized]);

  return <FeatureGatesContext.Provider value={ctxValue}>{props.children}</FeatureGatesContext.Provider>;
};
